<template>
  <div>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
import moment from "moment";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";

export default {
  data() {
    return {
      deleteWarningPromptValid: false,
      addNewInfoDataSidebar: false,
      isPromptActiveExpertizeLocal: false,
      addNewActSidebar: false,
      infoData: [],
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
      deleteData: [],
    };
  },
  components: {
    DeleteWarning,
    updateDeleteBtnCellRenderer,
    AgGridVue,
    Icon,
  },
  methods: {
    updateExpertize(temp) {
      const url = this.$router.resolve({
        name: "expertize",
        params: {
          data: JSON.stringify(temp),
        },
      }).href;
      window.open(url, "_blank");
    },
    expertizeDetail() {},
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },

    getExpertizeColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 70,
          pinned: "left",
          cellRendererFramework: "updateDeleteBtnCellRenderer",
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (val.toString().includes("Id") == false) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    addExpertizeData() {
      const vs = this.$vs;

      this.$store
        .dispatch("stock/listProductExpertize")
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    deleteExpertize() {
      this.deleteWarningPromptValid = true;
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    deleteSubmitAll() {
      var selectedRows = this.gridApi.getSelectedRows();
      selectedRows.forEach((val, index) => {
        this.deleteSubmit(val);
      });
    },
    deleteSubmit(data) {
      console.log(data);
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteProductExpertize", data.ProductExpertiseHeadId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.addExpertizeData();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
  },
  computed: {
    productExpertizeList: {
      get() {
        return this.$store.state.stock.ProductExpertizeList;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.addExpertizeData();
    this.$root.$on("expertizeDetail", (data) => {
      this.infoData = data;
      this.expertizeDetail(data);
    });
    this.$root.$on("editDataBtn", (data) => {
      this.updateExpertize(data);
    });
    this.$root.$on("deleteDataBtn", (data) => {
      this.deleteData = data;
      this.deleteExpertize(data);
    });
    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
    this.$root.$on("deleteSubmit", (data) => {
      if (this.wholeStockActions == true) this.deleteSubmitAll();
      else this.deleteSubmit(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("editDataBtn");
    this.$root.$off("deleteDataBtn");
    this.$root.$off("expertizeDetail");
    this.$root.$off("closeDeleteWarning");
    this.$root.$off("deleteSubmit");
  },
  watch: {
    productExpertizeList(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getExpertizeColumnList();
      }
      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 110px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
